// global.d.ts
import {
  paletteBase,
  gray,
  common,
  black,
  blue,
  purple,
  cherry,
  BACKDROP_DARK,
} from 'constants/colors';

const colorDefault = '#FB4E4E';

const primary = {
  main: purple[600],
  dark: purple[500],
  gray: '#868686',
  black: colorDefault,
  contrastText: common.white,
};

const background = {
  default: black.main,
  paper: black[100],
  step: black.main,
};

export const palette = {
  ...paletteBase,
  dark: {
    main: '#525067',
    100: '#3F3D56',
    200: '#3F4247',
  },
  primary,
  primary2: primary,
  secondary: {
    main: cherry[400],
    contrastText: common.white,
    dark: cherry[300],
  },
  button: {
    white: common.white,
  },
  background,
  background2: background,
  text: {
    disabled: gray[700],
    secondary: common.white,
    primary: common.white,
  },
  font: {
    main: common.white,
    gray: colorDefault,
    dark: colorDefault,
  },
  table: {
    main: black[100],
    textHeader: common.white,
    secondary: black[100],
    textHeaderSecondary: common.white,
    hover: black[300],
    row: black.main,
    header: black[200],
  },
  blue: {
    ...blue,
    600: black[200],
  },
  backdrop: {
    main: BACKDROP_DARK,
  },
};
